import type { Video } from '@/types/video';

export const videos: Video[] = [
  // ---------------- 电影 ----------------
  {
    id: 'm-001',
    title: '星海远征',
    category: 'movie',
    region: '美国',
    year: 2025,
    updateDate: '2025-09-28',
    rating: 8.9,
    views: 128600000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%20artwork%2C%20lone%20astronaut%20before%20a%20giant%20glowing%20planet%2C%20deep%20space%20nebula%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20dramatic%20moody%20lighting%2C%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-01&orientation=portrait',
    description:
      '人类首次跨越星系的远征启程，一支探险队深入未知星域，在浩瀚星海中寻找人类新的家园。面对未知的宇宙文明与重重危机，他们将如何抉择？',
    tags: ['科幻', '冒险', '太空'],
  },
  {
    id: 'm-002',
    title: '长夜将至',
    category: 'movie',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-09-25',
    rating: 8.4,
    views: 98600000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20thriller%20movie%20poster%20artwork%2C%20rainy%20dark%20city%20street%20at%20night%20with%20glowing%20orange%20streetlights%2C%20lone%20silhouette%20figure%2C%20deep%20shadows%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-02&orientation=portrait',
    description:
      '一场持续七天的暴雨将整座城市拖入长夜，刑警与时间赛跑，追查一桩连环悬案背后的真相。每个人都在隐藏秘密。',
    tags: ['悬疑', '犯罪', '剧情'],
  },
  {
    id: 'm-003',
    title: '浮生若梦',
    category: 'movie',
    region: '中国大陆',
    year: 2024,
    updateDate: '2025-08-30',
    rating: 8.1,
    views: 76200000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20romance%20period%20movie%20poster%20artwork%2C%20elegant%20couple%20in%20vintage%20clothing%20in%20a%20misty%20garden%2C%20soft%20golden%20hour%20light%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20dreamy%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-03&orientation=portrait',
    description:
      '民国年间，一段跨越阶层的爱恋在时代洪流中浮沉。当理想与现实碰撞，两个人能否守住最初的承诺？',
    tags: ['爱情', '年代', '文艺'],
  },
  {
    id: 'm-004',
    title: '逆光而行',
    category: 'movie',
    region: '中国大陆',
    year: 2024,
    updateDate: '2025-07-18',
    rating: 7.9,
    views: 65400000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20inspirational%20drama%20movie%20poster%20artwork%2C%20young%20runner%20sprinting%20towards%20bright%20sunlight%20on%20a%20stadium%20track%2C%20lens%20flare%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20dramatic%20moody%20lighting%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-04&orientation=portrait',
    description:
      '一位遭遇职业生涯重创的运动员，在低谷中重新出发。逆着光奔跑的人，终将抵达属于自己的终点线。',
    tags: ['励志', '运动', '剧情'],
  },
  {
    id: 'm-005',
    title: '山河故人',
    category: 'movie',
    region: '中国大陆',
    year: 2023,
    updateDate: '2025-06-12',
    rating: 8.6,
    views: 88900000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20historical%20epic%20movie%20poster%20artwork%2C%20ancient%20chinese%20mountain%20landscape%20with%20lone%20warrior%20silhouette%20at%20dusk%2C%20misty%20peaks%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-05&orientation=portrait',
    description:
      '乱世之中，家国与故土牵动着一代人的命运。跨越数十年的岁月，诉说着关于离别、坚守与重逢的史诗故事。',
    tags: ['历史', '剧情', '史诗'],
  },
  {
    id: 'm-006',
    title: '暗涌',
    category: 'movie',
    region: '中国香港',
    year: 2025,
    updateDate: '2025-09-15',
    rating: 8.3,
    views: 82300000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20crime%20noir%20movie%20poster%20artwork%2C%20shadowy%20detective%20in%20a%20rain%20soaked%20alley%20with%20neon%20orange%20reflections%2C%20deep%20shadows%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20moody%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-06&orientation=portrait',
    description:
      '平静的港口城市下暗流涌动，一名卧底警探游走在黑白之间。当身份逐渐模糊，信任成为最奢侈的赌注。',
    tags: ['犯罪', '悬疑', '警匪'],
  },
  {
    id: 'm-007',
    title: '归途列车',
    category: 'movie',
    region: '中国大陆',
    year: 2024,
    updateDate: '2025-05-20',
    rating: 8.0,
    views: 71200000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20road%20journey%20movie%20poster%20artwork%2C%20old%20train%20crossing%20a%20vast%20golden%20field%20at%20sunset%2C%20lone%20traveler%20at%20window%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20nostalgic%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-07&orientation=portrait',
    description:
      '一列开往故乡的绿皮火车，载着形形色色的旅人。陌生的他们在这趟旅程中，彼此照亮了各自的人生。',
    tags: ['剧情', '温情', '公路'],
  },
  {
    id: 'm-008',
    title: '苍穹之下',
    category: 'movie',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-09-02',
    rating: 8.7,
    views: 96400000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20aviation%20disaster%20movie%20poster%20artwork%2C%20fighter%20jet%20soaring%20through%20towering%20orange%20storm%20clouds%2C%20dramatic%20sky%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20epic%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-08&orientation=portrait',
    description:
      '一次突发的空中险情，将一群平凡的机组人员推向生死关头。在万米高空之上，他们用专业与勇气守护每一次起飞与降落。',
    tags: ['灾难', '剧情', '动作'],
  },
  {
    id: 'm-009',
    title: '追光者',
    category: 'movie',
    region: '韩国',
    year: 2024,
    updateDate: '2025-04-08',
    rating: 7.8,
    views: 59800000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20youth%20coming%20of%20age%20movie%20poster%20artwork%2C%20group%20of%20young%20friends%20laughing%20under%20warm%20city%20lights%20at%20night%2C%20blurry%20bokeh%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20nostalgic%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-09&orientation=portrait',
    description:
      '一群怀揣梦想的年轻人在大城市相遇，追逐着各自心中的光。青春里那些笨拙又热烈的瞬间，都值得被记住。',
    tags: ['青春', '剧情', '成长'],
  },
  {
    id: 'm-010',
    title: '迷雾之城',
    category: 'movie',
    region: '英国',
    year: 2023,
    updateDate: '2025-03-15',
    rating: 8.2,
    views: 67500000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20mystery%20movie%20poster%20artwork%2C%20foggy%20old%20european%20city%20street%20with%20dim%20orange%20lamps%20and%20silhouette%2C%20deep%20mist%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20eerie%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-movie-10&orientation=portrait',
    description:
      '浓雾笼罩的古老城市中，接连发生的离奇事件指向一段被掩埋的往事。真相藏在迷雾深处，等待有人揭开。',
    tags: ['悬疑', '推理', '剧情'],
  },

  // ---------------- 电视剧 ----------------
  {
    id: 't-001',
    title: '长安十二梦',
    category: 'tv',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-10-01',
    rating: 9.1,
    views: 186000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20drama%20poster%20artwork%2C%20grand%20tang%20dynasty%20palace%20at%20night%20with%20hanging%20orange%20lanterns%2C%20elegant%20figure%20in%20traditional%20robe%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-01&orientation=portrait',
    description:
      '盛唐长安，十二个时辰内危机四伏。一位少年与他的伙伴临危受命，在繁华都市的明暗之间揭开一场惊天阴谋。',
    tags: ['古装', '悬疑', '历史'],
  },
  {
    id: 't-002',
    title: '岁月长歌',
    category: 'tv',
    region: '中国大陆',
    year: 2024,
    updateDate: '2025-09-20',
    rating: 8.8,
    views: 154000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20family%20saga%20drama%20poster%20artwork%2C%20vintage%20chinese%20courtyard%20house%20with%20warm%20afternoon%20light%2C%20family%20silhouettes%20gathered%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20nostalgic%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-02&orientation=portrait',
    description:
      '一个普通家庭跨越四十年的命运变迁，从改革开放到新时代。岁月如歌，唱尽一代人的悲欢离合。',
    tags: ['年代', '家庭', '剧情'],
  },
  {
    id: 't-003',
    title: '硅谷风云',
    category: 'tv',
    region: '美国',
    year: 2025,
    updateDate: '2025-09-12',
    rating: 8.5,
    views: 132000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20tech%20startup%20drama%20poster%20artwork%2C%20modern%20glass%20office%20tower%20with%20glowing%20orange%20windows%20at%20dusk%2C%20reflective%20surface%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20moody%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-03&orientation=portrait',
    description:
      '一群年轻创业者怀揣改变世界的野心涌入硅谷。在财富、理想与人性之间，他们上演着一场没有硝烟的较量。',
    tags: ['商战', '剧情', '现代'],
  },
  {
    id: 't-004',
    title: '医者仁心',
    category: 'tv',
    region: '中国大陆',
    year: 2024,
    updateDate: '2025-08-25',
    rating: 8.6,
    views: 118000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20poster%20artwork%2C%20hospital%20corridor%20with%20warm%20glowing%20lights%20at%20night%2C%20doctor%20silhouette%20in%20white%20coat%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20serene%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-04&orientation=portrait',
    description:
      '急诊室里，每一位医生都在与时间赛跑。面对病痛与生死，他们用仁心仁术守护着一个个平凡家庭的希望。',
    tags: ['医疗', '剧情', '现实'],
  },
  {
    id: 't-005',
    title: '山海情缘',
    category: 'tv',
    region: '中国大陆',
    year: 2023,
    updateDate: '2025-07-14',
    rating: 8.3,
    views: 97600000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20ancient%20fantasy%20xianxia%20drama%20poster%20artwork%2C%20misty%20immortal%20mountains%20with%20waterfall%2C%20elegant%20figure%20in%20flowing%20robe%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20dreamy%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-05&orientation=portrait',
    description:
      '仙门弟子与凡间少女因一场意外结缘，跨越仙凡两界的爱恋注定坎坷。山海之间，缘分自有天定。',
    tags: ['古装', '仙侠', '爱情'],
  },
  {
    id: 't-006',
    title: '都市浮尘',
    category: 'tv',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-09-30',
    rating: 8.0,
    views: 104000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%20artwork%2C%20modern%20city%20skyline%20at%20night%20with%20warm%20orange%20window%20lights%20and%20reflections%2C%20lone%20figure%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20moody%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-06&orientation=portrait',
    description:
      '三个来自不同背景的年轻人在大城市打拼，追逐着各自的理想。霓虹之下，他们都是这座城市里的一粒浮尘。',
    tags: ['都市', '情感', '剧情'],
  },
  {
    id: 't-007',
    title: '破晓时分',
    category: 'tv',
    region: '韩国',
    year: 2024,
    updateDate: '2025-06-28',
    rating: 8.7,
    views: 121000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20korean%20thriller%20drama%20poster%20artwork%2C%20dark%20city%20rooftop%20at%20dawn%20with%20orange%20glow%20on%20horizon%2C%20determined%20silhouette%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20tense%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-07&orientation=portrait',
    description:
      '当正义被黑暗吞没，一位检察官选择独自追寻真相。破晓之前，是最漫长也最危险的黑夜。',
    tags: ['悬疑', '犯罪', '剧情'],
  },
  {
    id: 't-008',
    title: '江城往事',
    category: 'tv',
    region: '中国大陆',
    year: 2024,
    updateDate: '2025-05-30',
    rating: 8.4,
    views: 89200000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20nostalgic%20drama%20poster%20artwork%2C%20old%20riverside%20town%20with%20boats%20and%20warm%20orange%20sunset%20glow%20on%20water%2C%20vintage%20atmosphere%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20nostalgic%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-08&orientation=portrait',
    description:
      '九十年代的江城，一群年轻人的青春与梦想在时代浪潮中起落。多年后回望，那些往事依旧滚烫。',
    tags: ['年代', '青春', '剧情'],
  },
  {
    id: 't-009',
    title: '无间',
    category: 'tv',
    region: '中国香港',
    year: 2025,
    updateDate: '2025-10-05',
    rating: 8.9,
    views: 143000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20crime%20undercover%20drama%20poster%20artwork%2C%20two%20opposing%20silhouettes%20facing%20each%20other%20in%20rainy%20neon%20alley%2C%20orange%20and%20dark%20tones%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20tense%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-09&orientation=portrait',
    description:
      '潜伏与追捕，信任与背叛，一场横跨多年的黑白博弈。身处无间深渊的人，究竟谁能全身而退？',
    tags: ['犯罪', '悬疑', '警匪'],
  },
  {
    id: 't-010',
    title: '星辰大海',
    category: 'tv',
    region: '中国大陆',
    year: 2023,
    updateDate: '2025-04-22',
    rating: 8.1,
    views: 83400000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20youth%20inspirational%20drama%20poster%20artwork%2C%20students%20standing%20on%20a%20hill%20watching%20a%20warm%20orange%20sunrise%20and%20distant%20sea%2C%20hopeful%20mood%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-tv-10&orientation=portrait',
    description:
      '一所小城的中学里，一群少年为了各自的梦想奋力拼搏。星辰大海的征途，从脚下的每一步开始。',
    tags: ['青春', '励志', '校园'],
  },

  // ---------------- 综艺 ----------------
  {
    id: 'v-001',
    title: '我们的歌',
    category: 'variety',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-09-27',
    rating: 8.8,
    views: 112000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20music%20show%20poster%20artwork%2C%20glowing%20concert%20stage%20with%20warm%20orange%20spotlights%20and%20microphone%20silhouette%2C%20confetti%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20energetic%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-01&orientation=portrait',
    description:
      '实力唱将与新生代歌手同台合作，共同演绎经典与新作。音乐的火花在舞台上不断碰撞，唱响属于我们的歌。',
    tags: ['音乐', '竞演', '真人秀'],
  },
  {
    id: 'v-002',
    title: '奔跑吧少年',
    category: 'variety',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-09-22',
    rating: 8.3,
    views: 98600000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20outdoor%20game%20show%20poster%20artwork%2C%20energetic%20young%20people%20running%20through%20a%20sunny%20orange%20field%20with%20colorful%20flags%2C%20motion%20blur%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20fun%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-02&orientation=portrait',
    description:
      '一群活力少年在户外完成各种趣味挑战，团队协作与爆笑场面轮番上演。青春的汗水，在奔跑中尽情挥洒。',
    tags: ['竞技', '户外', '真人秀'],
  },
  {
    id: 'v-003',
    title: '音乐现场',
    category: 'variety',
    region: '中国大陆',
    year: 2024,
    updateDate: '2025-08-18',
    rating: 8.5,
    views: 87600000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20live%20music%20festival%20poster%20artwork%2C%20crowd%20silhouettes%20with%20raised%20hands%20before%20glowing%20orange%20stage%2C%20hazy%20lights%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20immersive%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-03&orientation=portrait',
    description:
      '每期邀请不同风格的音乐人带来现场演出，从摇滚到民谣，用最真实的现场点燃你的耳朵。',
    tags: ['音乐', '现场', '演出'],
  },
  {
    id: 'v-004',
    title: '美食奇遇记',
    category: 'variety',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-09-08',
    rating: 8.6,
    views: 92300000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20food%20travel%20show%20poster%20artwork%2C%20steaming%20rustic%20dishes%20on%20a%20wooden%20table%20with%20warm%20orange%20lantern%20light%2C%20rich%20textures%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20appetizing%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-04&orientation=portrait',
    description:
      '跟随美食探员走遍大江南北，寻找藏在街头巷尾的宝藏美味。每一道菜背后，都有一段动人的故事。',
    tags: ['美食', '旅行', '纪实'],
  },
  {
    id: 'v-005',
    title: '极限挑战',
    category: 'variety',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-10-02',
    rating: 8.4,
    views: 108000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20adventure%20challenge%20show%20poster%20artwork%2C%20daring%20figures%20crossing%20a%20suspension%20bridge%20over%20a%20gorge%20at%20orange%20sunset%2C%20epic%20scale%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20thrilling%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-05&orientation=portrait',
    description:
      '嘉宾们接受极限体能与智力挑战，在全实景的任务中突破自我。每一次闯关，都是对勇气与智慧的考验。',
    tags: ['竞技', '挑战', '真人秀'],
  },
  {
    id: 'v-006',
    title: '一起来露营',
    category: 'variety',
    region: '中国大陆',
    year: 2024,
    updateDate: '2025-07-26',
    rating: 8.2,
    views: 76400000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20camping%20lifestyle%20show%20poster%20artwork%2C%20cozy%20tent%20and%20campfire%20glow%20under%20a%20starry%20night%20sky%2C%20warm%20orange%20lights%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20peaceful%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-06&orientation=portrait',
    description:
      '邀请朋友一起走进自然，搭帐篷、生篝火、聊心事。在星空下放慢脚步，感受治愈又松弛的慢生活。',
    tags: ['生活', '治愈', '慢综艺'],
  },
  {
    id: 'v-007',
    title: '舞台之王',
    category: 'variety',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-09-18',
    rating: 8.7,
    views: 119000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20dance%20competition%20show%20poster%20artwork%2C%20dynamic%20dancer%20silhouette%20mid%20air%20under%20warm%20orange%20spotlight%20beams%2C%20dramatic%20motion%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20powerful%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-07&orientation=portrait',
    description:
      '顶尖舞者汇聚一堂，用身体讲述故事，用舞台证明实力。谁能一路过关斩将，加冕真正的舞台之王？',
    tags: ['舞蹈', '竞演', '真人秀'],
  },
  {
    id: 'v-008',
    title: '头脑风暴',
    category: 'variety',
    region: '中国大陆',
    year: 2024,
    updateDate: '2025-06-16',
    rating: 8.4,
    views: 71200000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20quiz%20talk%20show%20poster%20artwork%2C%20elegant%20studio%20with%20warm%20orange%20geometric%20lighting%20and%20abstract%20shapes%2C%20modern%20set%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20smart%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-08&orientation=portrait',
    description:
      '知识与脑洞齐飞，嘉宾们在妙趣横生的问答与辩论中碰撞观点。一场关于智慧的欢乐风暴就此展开。',
    tags: ['脱口秀', '益智', '访谈'],
  },
  {
    id: 'v-009',
    title: '明星大侦探',
    category: 'variety',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-09-25',
    rating: 8.9,
    views: 126000000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20mystery%20game%20show%20poster%20artwork%2C%20victorian%20mansion%20hallway%20with%20candlelight%20and%20clue%20markers%2C%20eerie%20orange%20glow%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20mysterious%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-09&orientation=portrait',
    description:
      '每位嘉宾化身角色走进谜案现场，通过线索推理找出真正的凶手。烧脑剧情与爆笑反转，一期一故事。',
    tags: ['推理', '悬疑', '真人秀'],
  },
  {
    id: 'v-010',
    title: '声临其境',
    category: 'variety',
    region: '中国大陆',
    year: 2025,
    updateDate: '2025-08-12',
    rating: 8.6,
    views: 89700000,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20voice%20acting%20show%20poster%20artwork%2C%20vintage%20radio%20microphone%20glowing%20with%20warm%20orange%20light%20in%20a%20dark%20studio%2C%20sound%20waves%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20dramatic%20atmospheric%2C%20no%20text%2C%20highly%20detailed&width=600&height=800&seq=peach-var-10&orientation=portrait',
    description:
      '声音的竞技场，配音演员用声音塑造百变角色。听他们用一副嗓子，演绎万千人生。',
    tags: ['配音', '竞演', '表演'],
  },
];